// project import
import { UserProfile } from 'types/auth';
import GetSubscriptions from './subscriptions';

// ==============================|| MENU ITEMS ||============================== //

// const menuItems: { items: NavItemType[] } = {
//   items: [GetSubscriptions]
// };

interface GetNavigationMenuItemsProps {
  user: UserProfile
}


const GetNavigationMenuItems = ({ user }: GetNavigationMenuItemsProps) => {
  return { items: GetSubscriptions(user) };
}

export default GetNavigationMenuItems;
